<script setup>
  import { computed } from "vue";
  import { formatLocalized } from '@/composables/useDateHelper';
  import { useMapStore } from "@/stores/MapStore";
  import SegmentedControl from "@/components/controls/SegmentedControl.vue";
  import SegmentedControlButton from "@/components/controls/SegmentedControlButton.vue";    
  
  const mapStore = useMapStore();

  const precipAccumulationTimestamp = computed(() => {
    const updatedTimestamp = mapStore.state.settings['precip-accumulation']?.latestTimestamp;
    if (updatedTimestamp) {
      const date = new Date(updatedTimestamp);
      return formatLocalized(date, 'LLL d, y p');
    }
    return 'N/A';
  })

</script>

<template>
  <div class="jwx-timeline jwx-map__timeline jwx-map-block jwx-map-block--column jwx-map-block--transparent-border">
    <div class="jwx-layer-dashboard">
      <h3 class="jwx-map-block__title">Accumulation Period (Past)</h3>
      <SegmentedControl
        @click="mapStore.customizedMapUpdate('obs')"
        v-model.number="mapStore.state.settings['precip-accumulation'].period"
        label="Select the time period of the onsite reports to show."
        class="w-100"
      >
        <SegmentedControlButton :value="24">24 Hours</SegmentedControlButton>
        <SegmentedControlButton :value="48">48 Hours</SegmentedControlButton>
        <SegmentedControlButton :value="72">72 Hours</SegmentedControlButton>
      </SegmentedControl>
      <p class="jwx-map-block__text">Updated: {{ precipAccumulationTimestamp }}</p>
    </div>
  </div>
</template>